<template>
    <div>
        <h2>{{ $t('upcoming-notices') }}</h2>
        <p v-html="$t('upcoming-detail')"></p>
        <NoticeListing :notices="notices"
                       :keys="['notice_id','notice_type','address','approval_type','ward', 'meeting_date', 'appeal_date'] "
                       :dates="['meeting_date', 'appeal_date']"
											 :default_column="sort.column"
											 :default_direction="sort.direction"
                       v-on:sort_click="sort_url"></NoticeListing>
    </div>
</template>

<script>
import NoticeListing from '@/components/NoticeListing'
import OpenData from '@/libraries/OpenData'

	export default {
		components: { NoticeListing },
		created() {
			this.fetch();
		},

		data() {
			return {
				notices: [],
				sort: {
					column: 'appeal_date',
					direction: 'DESC',
				}
			}
		},

		computed: {
			order_parameters() {
				return [{key: this.sort.column, direction: this.sort.direction }];
			},

			parameters() {
				let where_parameters = this.filters;
				let order_parameters = this.order_parameters;
				return { where_parameters, order_parameters };
			},

			filters() {
				const now = this.$moment().format('YYYY-MM-DD');
				let where_parameters = [];
				where_parameters.push([{column: 'meeting_date', type: '>=', params: [now]}, {column: 'appeal_date', type: '>=', params: [now]}]);
				return where_parameters;
			},

		},

		methods: {
			sort_url(sort) {
				this.sort = sort;
				this.fetch();
			},

			async fetch() {
				const params = this.parameters;
				const data = await OpenData.getResults(this.$PUBLIC_NOTICES_API,params);
				this.notices = data;
			},


		}

	}
</script>

<style scoped>

</style>
